import { Grid, Typography } from "@mui/material";

import CopyToClipboard from "components/CopyToClipboard";
import Pagination from "components/Pagination";
import Table from "components/Table";

const headers = [
  {
    key: "invitationCode",
    name: "کد دعوت",
    align: "center",
  },
  {
    key: "referralPart",
    align: "center",
    name: "سهم شما / سهم دوستان",
  },
  {
    name: "Action",
    align: "center",
    key: "actions",
  },
];

function TableReferral({ allReferral, getReferralList }) {
  const handleChangePaginate = ({ page, perPage }) => {
    getReferralList({ pageNumber: page, pageSize: perPage });
  };

  const formattedDataList = allReferral?.data?.map((data) => {
    return {
      invitationCode: (
        <Typography color="text.main" variant="h5">
          {data.referralCode}
        </Typography>
      ),

      referralPart: (
        <Typography color="text.main" variant="h5">
          {`${data.referralPercentChild} %`} /{" "}
          {`${data.referralPercentParent} %`}{" "}
        </Typography>
      ),

      actions: <CopyToClipboard value={data?.referralCode} />,
    };
  });

  return (
    <>
      <Grid item xs={12}>
        <Table headers={headers} items={formattedDataList} hideBorders={true} />
      </Grid>

      <Grid item xs={12} mt={2}>
        <Pagination
          count={allReferral?.totalPages}
          perPage={allReferral?.pageSize}
          onChange={handleChangePaginate}
        />
      </Grid>
    </>
  );
}

export default TableReferral;
